export const HIRING_STATUS_IDS = {
  Hired: "a7db4d99-448f-4993-be64-e2000d499200",
  "Short Listed": "b4c604a1-7cb6-4e8d-8bd8-b4d7e92a8fbb",
  "On Hold": "a3f100dc-eedf-4965-82c2-84e3025dc35b",
  Rejected: "520f0726-efe2-4f5a-8ad4-81436a979663",
};

export const HIRING_STATUS_COLORS = {
  "In Progress": "#2F80ED",
  "In Pipeline": "#2F80ED",
  "Short Listed": "#00B8D9",
  Hired: "#4CC948",
  "On Hold": "#FFC857",
  Rejected: "#FF1C58",
};

export const STATUS_CONFIG = {
  "In Progress": { label: "Select", color: "#8A9199", bg: "#F5F6F8", border: "#C4CAD3" },
  "In Pipeline": { label: "Select", color: "#8A9199", bg: "#F5F6F8", border: "#C4CAD3" },
  "Short Listed": { label: "Shortlisted", color: "#00B8D9", bg: "#E6FAFF", border: "#00B8D9" },
  Hired: { label: "Hired", color: "#4CC948", bg: "#F0FFF4", border: "#4CC948" },
  Rejected: { label: "Rejected", color: "#FF1C58", bg: "#FFF0F3", border: "#FF1C58" },
  "On Hold": { label: "On Hold", color: "#FFC857", bg: "#FFFBEE", border: "#FFC857" },
};

export const JOB_STAGES = [
  { name: "Pre-Screening", abbrev: "Pre",   id: "3dab71cf-c680-4983-a109-1cff0953999b", scoreKey: "prescreening_score" },
  { name: "Voice Call",    abbrev: "Voice",  id: "fd40e3d2-38a9-4cef-937a-93ef6a42d045", scoreKey: "telephonic_score" },
  { name: "Assessment",   abbrev: "Asmt",   id: "293e9b95-4610-48f2-ae93-c7264cae7d6a", scoreKey: "assessment_score" },
  { name: "Video Call",   abbrev: "Video",  id: "ed658e02-1549-4d9e-a735-1f1c1e385f46", scoreKey: "video_interview_score" },
];

export const SORT_ROWS = [
  { label: "Created At", field: "created_at" },
  { label: "Name", field: "name" },
  { label: "Resume Score", field: "resume_score" },
  { label: "Pre Screening Score", field: "prescreening_score" },
  { label: "Stage Score", field: "hiring_stage_score" },
  { label: "Hiring Status", field: "hiring_status" },
];
